module.exports = __webpack_public_path__ + "static/marceno-2dab6507946594a7ee8b45f68225c45c.jpg";